module.exports = __webpack_public_path__ + "static/media/baloon4.ff4e6481.png";